import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { Navigate } from 'react-router-dom';
import { AuthContext } from '../context/AuthContext';
import Layout from './Layout';
import LoadingScreen from './LoadingScreen';
import { canAccessRoute } from '../utils/permissions';

const PrivateRoute = ({ children, requiredPermission }) => {
  const { user, loading } = useContext(AuthContext);

  if (loading) {
    return <LoadingScreen />;
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  if (!canAccessRoute(user, requiredPermission)) {
    return (
      <Layout>
        <div className="page-content">
          <div className="ui-info-panel ui-info-panel--warning">
            <h1>Acesso negado</h1>
            <p>Você não tem permissão para acessar esta área.</p>
          </div>
        </div>
      </Layout>
    );
  }

  return <Layout>{children}</Layout>;
};

PrivateRoute.propTypes = {
  children: PropTypes.node.isRequired,
  requiredPermission: PropTypes.string
};

export default PrivateRoute;
